import React, { useEffect, useState } from 'react'
import {  Header, Form, TextArea, Button, Loader, Dimmer, Message } from 'semantic-ui-react'


import './Demo.css'

import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import bgImage2 from "../../images/BG2.png";

// const options = [
//   { key: '0', text: 'Qualification', value: 'Qualification' },
//   { key: '1', text: 'DropOut/Failed', value: 'DropOut/Failed' },
//   { key: '2', text: 'Undergraduate', value: 'Undergraduate' },
//   { key: '3', text: 'Graduate', value: 'Graduate' },
//   { key: '4', text: 'Intermediat', value: 'Intermediat' },
// ]

export const Demo = () => {
  const [showErrMsg, setShowErrMsg] = useState<string | null>(null);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState<boolean>(false);
  const [form, setForm] = useState<{
    fullName: string,
    contactNo: string,
    emailId: string,
    class: string,
    about: string,


  }>({
    fullName: "",
    contactNo: "",
    emailId: "",
    class:"",
    about: "",
  })


  useEffect(() => {
    if (showSuccessMsg) {
      setTimeout(() => {
        setShowSuccessMsg(false);
      },2000)
    }
  }, [showSuccessMsg])
  const handleChange = (e: any, {value, name}: any) => {
    setForm({
      ...form,
      [name]: value
    })
  }

  const submitForm = async () => {
    let url = process.env.REACT_APP_FORM_URL2;
    if (!url) {
      return;
    }

    url = url.replace("{{FullName}}", form.fullName);
    url = url.replace("{{ContactNo}}", form.contactNo);
    url = url.replace("{{EmailID}}", form.emailId);
    url = url.replace("{{Class}}", form.class);
    url = url.replace("{{Description}}", form.about);
    setShowLoader(true);
    const iframe = document.createElement('iframe')
    iframe.src = url;
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    setTimeout(() => {
      document.body.removeChild(iframe);
      setShowLoader(false);
      setForm({
        fullName: "",
        contactNo: "",
        emailId: "",
        class:"",
        about: ""  ,

      })
      setShowSuccessMsg(true);
    }, 1000)
  }

  const validator = (name: string, value: string) => {
    switch(name) {
      case "fullName":
        return value.length >= 3;
        case "collegeName":
          return value.length >= 3;
      case "contactNo":
        return String(value)
          .toLowerCase()
          .match(
            /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
          );
      case "emailId":
        return String(value)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
        }
  }

  const handleSubmit = async () => {
    if (form.fullName && form.about && form.contactNo && form.emailId) {
      if (!validator("fullName", form.fullName)) {
        setShowErrMsg("Full Name should be atleast 3 characters");
        return;
      }

    

      if (!validator("contactNo", form.contactNo)) {
        setShowErrMsg("Invalid Contact No");
        return;
      }

      if (!validator("emailId", form.emailId)) {
        setShowErrMsg("Invalid Email Id");
        return;
      }

      setShowErrMsg(null);
      await submitForm();
    } else {
      setShowErrMsg("* fields are required")
    }
    if (!validator("collegeName", form.about)) {
      setShowErrMsg("About should be atleast 3 characters");
      return;
    }
  }

  return (
    <div className='demo' style={{ backgroundImage: `url(${bgImage2})`, backgroundSize: 'cover', background: 'cover' }}>
      <div  className='demo__left1'>
      <div className='demo__left'>
        <Header as={'h1'} size='huge'>
        Enquiry About Admissions
        </Header>
        <p>
        Get the information on the availability of the seats in the class for you child
        </p>
        <div className='demo-flex'>
                <div  className='demo-menu-item2'>
                  <LocalPhoneOutlinedIcon  className='icon'></LocalPhoneOutlinedIcon> 
                  <div >
                  {/* <div style={{fontSize:'12px',color:'rgba(255, 255, 255, 0.8)'}} >Tel</div> */}
                  <div  >+919000284777</div>
                  </div>
                </div>
                <div  className='demo-menu-item2'>
                   <EmailOutlinedIcon className='icon'></EmailOutlinedIcon>
                  
                     <div >
                  {/* <div style={{fontSize:'12px',color:'rgba(255, 255, 255, 0.8)'}} >Mail</div> */}
                  <div  >saigrammarhs@gmail.com</div>
                  </div>
                </div>
                <div  className='demo-menu-item2'>
                   <LocationOnOutlinedIcon className='icon'></LocationOnOutlinedIcon>
                   <div >
                  {/* <div style={{fontSize:'12px',color:'rgba(255, 255, 255, 0.8)'}} >Address</div> */}
                  <div  >8-7-12/9/1. Padmashalipuram,
Sai Colony, Telangana NGOS Colony, 
Katedhan, Telangana 500077</div>
                  </div>
                </div>
                </div>
      </div>
      <div className='demo__right'>
        <Form onSubmit={handleSubmit}>
          <Form.Input
            fluid
            className='input'
            label='Name*'
            placeholder='Full Name'
            name="fullName"
            onChange={handleChange}
            value={form.fullName}
          />
        
          <Form.Input
            fluid
            label='Contact No*'
            placeholder='Contact No'
            name="contactNo"
            onChange={handleChange}
            value={form.contactNo}
          />
          <Form.Input
            fluid label='Email Id*'
            placeholder='Email Id'
            name="emailId"
            onChange={handleChange}
            value={form.emailId}
          />
           <Form.Input
            fluid label='Class to Admit*'
            placeholder='Class'
            name="class"
            onChange={handleChange}
            value={form.class}
          />
        
          <Form.Field
            control={TextArea}
            label='Description'
            placeholder='...'
            name="about"
            onChange={handleChange}
            value={form.about}
          />
            
          {showErrMsg && <div style={{color: "red"}}>{showErrMsg}</div>}
          <Dimmer active={showLoader}>
            <Loader />
          </Dimmer>
          <div className='demo__btn'>
            <Form.Field primary control={Button}  className='button'>
              Submit
            </Form.Field>
          </div>
        </Form>
        {showSuccessMsg && <Message positive>
          <Message.Header>Application successfully submitted!!</Message.Header>
        </Message>}
      </div>
      </div>
    </div>
  )
}